import React from 'react'; //eslint-disable-line

const BoltIcon = props => {
  const placement = props.placement ? `bolt-svg ${props.placement}` : 'bolt-svg';

  return (
    <svg version="1.1"
      className={placement}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 288 288"
      style={{enableBackground: 'new 0 0 288 288'}}
      xmlSpace="preserve">
      {/* <style type="text/css">
            {`.st0{fill:#FFFFFF}`}
            {`.st1{fill:var(--accent-green_}`}
        </style> */}
      {/* <circle class="st0" cx="144" cy="225.4" r="7.3"/> */}
      <polygon className="bolt-icon" points="195.9,19 109.4,147.5 131.5,157.7 100.1,266.6 186.6,138.1 164.6,127.8 "/>
    </svg>
  );
};

export default BoltIcon;
